
































































import Card from '@/components/Card.vue'
import ActionButton from '@/components/ActionButton.vue'
import Table from '@/components/Table.vue'
import {
  createOrUpdateTopUpDeal,
  getPreTopupStatus,
  getTopUpDeals,
  togglePreTopup,
} from '@/api/Topup/topup.api'
import { TableHeader } from '@/utils/interfaces'
import DealsDialog from '@/components/Services/TopUps/DealsDialog.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { TopUpDeal } from '@/utils/interfaces/topup.interface'
import moment from 'moment'
import DealsDetails from './DealsDetails.vue'
import FlatTable from '~/components/FlatTable.vue'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import { AxiosError } from 'axios'
import TableSwitch from '~/components/TableSwitch.vue'

export default tableHandler<TopUpDeal>().extend({
  components: {
    appCard: Card,
    appActionButton: ActionButton,
    appTable: Table,
    appDealsDialog: DealsDialog,
    appDealsDetails: DealsDetails,
    FlatTable,
    FlatCard,
    TextButton,
    TableSwitch,
  },
  data: function() {
    return {
      getter: getTopUpDeals,
      headers: [
        {
          text: this.$t('title'),
          value: 'title',
        },
        {
          text: this.$t('start'),
          value: 'start_date',
        },
        {
          text: this.$t('end'),
          value: 'end_date',
        },
        {
          text: this.$t('has_bonus'),
          value: 'promotion',
          notShow: !(this.$p.isMaikel || this.$p.isSuperuser),
        },
        {
          text: this.$t('actions'),
          value: 'actions',
          notShow: !(this.$p.isSuperuser || this.$p.isMaikel),
        },
      ] as TableHeader[],
      pretopupStatus: {
        is_active: true,
      },
      loadingItem: '' as string | undefined,
    }
  },
  methods: {
    formatDate(date: string) {
      moment.locale(this.$store.getters.profile.lang)
      return moment(date).format('ddd, MMM DD YYYY')
    },
    async togglePreTopUp() {
      try {
        await togglePreTopup(this.pretopupStatus)
        this.$toast.success(this.$t('topup-pre-topup-status-changed'))
      } catch (error) {
        if ((error as AxiosError)?.response?.data) {
          this.pretopupStatus.is_active = !this.pretopupStatus.is_active
        }
        this.$toast.error(this.$t('topup-pre-topup-status-change-failed'))
      }
    },
    async toggle(item: TopUpDeal) {
      try {
        this.loadingItem = item.uuid
        await createOrUpdateTopUpDeal(item)
      } catch {
        item.promotion = !item.promotion
      } finally {
        this.loadingItem = ''
      }
    },
  },
  async mounted() {
    try {
      const response = await getPreTopupStatus()
      this.pretopupStatus.is_active = response.data.status
    } catch {
      try {
        const response = await getPreTopupStatus()
        this.pretopupStatus.is_active = response.data.status
      } catch {
        this.$toast.error(this.$t('pre_topup_status_fetch_failed'))
      }
    }
  },
})
